import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  SectionFavoriteError,
  sectionFavoritesService,
  type SectionFavoriteRequest,
} from '../services/sectionFavoritesService';

export const useSectionFavorites = () =>
  useQuery({
    queryKey: ['section-favorites'],
    queryFn: () => sectionFavoritesService.list(),
    staleTime: 30_000,
    retry: false,
  });

export const useSaveSectionFavorite = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (req: SectionFavoriteRequest) =>
      sectionFavoritesService.create(req),
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['section-favorites'] });
    },
  });
};

export const useSectionFavoritePreview = (id: string | null) =>
  useQuery({
    queryKey: ['section-favorite-preview', id],
    queryFn: () => sectionFavoritesService.preview(id as string),
    enabled: !!id,
    staleTime: Infinity,
    retry: false,
  });

export { SectionFavoriteError };
